import React from "react";
import { Skeleton } from "@mui/material";

interface NotificationSkeletonProps {
    mobile?: boolean;
}

const NotificationSkeleton: React.FC<NotificationSkeletonProps> = ({
    mobile = false,
}) => {
    if (mobile) {
        // Mobile layout - simpler, full-width design
        return (
            <div className="flex gap-3 py-3 w-full">
                {/* Avatar */}
                <Skeleton variant="circular" width={40} height={40} />

                {/* Content */}
                <div className="flex flex-col gap-1 flex-1">
                    <Skeleton
                        width="90%"
                        height={16}
                        sx={{ fontSize: "0.875rem" }}
                    />
                    <Skeleton
                        width="70%"
                        height={16}
                        sx={{ fontSize: "0.875rem" }}
                    />
                </div>
            </div>
        );
    }

    // Desktop/sidebar layout - original three-column design
    return (
        <div className="flex gap-3 justify-between py-3">
            {/* Left section with dot and avatar */}
            <div className="md:w-1/6 w-4 relative flex items-start md:items-center justify-between md:gap-2">
                {/* Avatar circle - only visible on desktop */}
                <div className="hidden md:block">
                    <Skeleton
                        variant="circular"
                        width={32}
                        height={32}
                        sx={{ ml: 1 }}
                    />
                </div>
            </div>

            {/* Middle section with message */}
            <div className="flex flex-col md:pl-3 w-5/6 gap-1">
                <Skeleton
                    width="85%"
                    height={16}
                    sx={{ fontSize: "0.875rem" }}
                />
                <Skeleton
                    width="60%"
                    height={16}
                    sx={{ fontSize: "0.875rem" }}
                />
            </div>

            {/* Right section with date */}
            <div className="w-1/6 relative flex items-start justify-center ml-2">
                <Skeleton width={40} height={12} sx={{ fontSize: "0.75rem" }} />
            </div>
        </div>
    );
};

export default NotificationSkeleton;
